import { render, staticRenderFns } from "./CameraSystem.vue?vue&type=template&id=87cde9d2&"
import script from "./CameraSystem.vue?vue&type=script&lang=ts&"
export * from "./CameraSystem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports